import React from "react";
import hamburgerIcon from "../../assets/icons/Menu.svg";

const Hamburger = () => {
  return <img src={hamburgerIcon} alt="Hamburger Icon" />;
};

export default Hamburger;
